import { MEDIA } from '@/constants/config'

const bydbSelectStyles = {
  gridColumnStart: '1',
  gridColumnEnd: '3',
  borderColor: 'bydb-white',
  marginBottom: '12px',

  label: {
    fontFamily: 'din-medium-cn',
    fontSize: '18px',
    background: 'transparent',
    pb: '8px',
  },

  '[class$="placeholder"]': {
    color: 'bydb-light-gray',
    fontFamily: 'din-light-cn',
    fontSize: '18px',
  },

  '[class$="-indicatorSeparator"]': {
    display: 'none',
  },

  'span+div': {
    borderColor: 'bydb-white',
    background: 'bydb-black',
    color: 'bydb-white',
    borderRadius: '20px',
    boxShadow: 'none',
    cursor: 'pointer',
  }, // workaround to style the dropdown

  '[class$="-control"]': {
    height: '45px',
    pl: '8px',
  },

  '[class*="control"]:has(input[aria-expanded="true"])': {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'bydb-green',
    outline: 'none',
    borderBottomLeftRadius: 'unset',
    borderBottomRightRadius: 'unset',
  },

  'div[class$="singleValue"]': {
    color: 'bydb-white',
  },

  '[class*="menu"]': {
    top: '25px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'bydb-green',
    backgroundColor: 'bydb-black',
    borderRadius: '0px 0px 16px 16px',
    borderTop: 'none',
    paddingTop: '12px',
    fontFamily: 'din-light-cn',

    '& *': {
      color: 'bydb-light-gray',
    },

    'div[role="listbox"]': {
      paddingBottom: 0,
      borderRadius: '0px 0px 16px 16px',
      boxShadow: 'none',
      background: 'bydb-black',

      'div[class$="option"]': {
        background: 'transparent',
        color: 'bydb-light-gray',
        px: '6px',
        py: '6px',
        ml: '12px',
        width: 'calc(100% - 24px)',

        '&:first-of-type': {
          pt: '8px',
          borderTopWidth: '1px',
          borderTopStyle: 'solid',
          borderTopColor: 'bydb-white',
        },
      },

      'div[class$="option"]:hover': {
        backgroundColor: 'bydb-green',
        color: 'bydb-black',
        cursor: 'pointer',
      },

      '::-webkit-scrollbar': {
        width: 6,
        borderRadius: '3px',
      },

      '::-webkit-scrollbar-track': {
        background: 'transparent',
        borderRadius: '3px',
      },

      '::-webkit-scrollbar-thumb': {
        background: 'bydb-green',
        borderRadius: '3px',
      },
    },

    '[class$="-indicatorSeparator"]': {
      display: 'none',
    },
  },

  ['.error-select > [class$="-control"]']: {
    borderColor: 'error',
  },
}

const greatestHitsSelectStyles = {
  gridColumnStart: '1',
  gridColumnEnd: '3',
  color: 'textDark',
  label: {
    color: 'textDark',
    fontFamily: 'regular',
    fontSize: '17px',
    pb: '9px',
  },
  '[class$="placeholder"]': {
    color: 'gray',
  },
  '[class^="error-select"]': {
    '[class$="control"]': {
      border: '1px solid',
    },
  },
  'span+div': {
    borderColor: 'textDark',
    borderRadius: '0',
  },
  div: {
    span: {
      display: 'none',
    },
    div: {
      svg: {
        fill: 'textDark',
      },
    },
  },
}

const ultimateCoachingTripSelectStyles = {
  gridColumnStart: '1',
  gridColumnEnd: '3',
  color: 'textLight',
  label: {
    color: 'textLight',
    fontFamily: 'regular',
    fontSize: '16px',
    pb: '9px',
  },
  '[class$="control"]': {
    backgroundColor: 'background',
    div: {
      color: 'textLight',
      fontSize: '16px',
    },
  },
  '[class$="menu"]': {
    color: 'textDark',
    fontSize: '16px',
  },
  '[class$="placeholder"]': {
    color: 'textLight',
    fontFamily: 'light',
  },
  '[class^="error-select"]': {
    '[class$="control"]': {
      border: '1px solid',
    },
  },
  'span+div': {
    borderColor: 'textLight',
    borderRadius: '0',
  },
  div: {
    span: {
      display: 'none',
    },
    div: {
      svg: {
        fill: 'textLight',
      },
    },
  },
}

const stwSelectStyles = {
  gridColumnStart: '1',
  gridColumnEnd: '3',
  marginBottom: '15px',

  label: {
    fontFamily: 'din-medium-cn',
    fontSize: '18px',
    background: 'transparent',
    pb: '8px',
  },

  '[class$="placeholder"]': {
    color: 'rgba(135,135,135,.5)',
    fontFamily: 'din-light-cn',
    fontSize: '16px',
  },

  '[class$="-indicatorSeparator"]': {
    display: 'none',
  },

  'span+div': {
    borderColor: 'white',
    background: 'white',
    color: 'bydb-white',
    borderRadius: '20px',
    boxShadow: 'none',
    cursor: 'pointer',
  }, // workaround to style the dropdown

  '[class$="-control"]': {
    height: '45px',
    pl: '8px',
    boxShadow: '0 0 0 1000px white inset',
    backgroundColor: 'white',
    transition: 'background-color 5000s ease-in-out 0s',
    color: '#222222',
    outline: 'none',
    display: 'flex',
    alignItems: 'center',

    '::placeholder': {
      fontFamily: 'din-light-cn',
      fontSize: '16px',
      color: 'rgba(135,135,135,.5)',
      display: 'flex',
      alignItems: 'center',
    },

    [`&:focus,
      &:hover,
      &:active
    `]: {
      outline: 'none',
      borderColor: 'white !important',
    },

    '&:-webkit-autofill::first-line': {
      fontSize: '16px !important',
      color: '#222222 !important',
    },

    '&:-webkit-autofill': {
      boxShadow: '0 0 0 1000px white inset',
      WebkitTextFillColor: '#222222',
      transition: 'background-color 5000s ease-in-out 0s',
      color: '#222222 !important',
    },
    '&:-webkit-autofill:hover': {
      color: '#222222 !important',
    },
    '&:-webkit-autofill:focus': {
      boxShadow: '0 0 0 1000px white inset',
      color: '#222222 !important',
    },
  },

  '[class*="control"]:has(input[aria-expanded="true"])': {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'white !important',
    backgroundColor: 'white',
    outline: 'none !important',
    borderBottomLeftRadius: 'unset',
    borderBottomRightRadius: 'unset',
  },

  'div[class$="singleValue"]': {
    color: '#222222',
    fontFamily: 'din-light-cn',
    fontSize: '16px',
  },

  '[class*="menu"]': {
    top: '34px',
    backgroundColor: 'white',
    borderRadius: '0px 0px 16px 16px',
    fontFamily: 'din-light-cn',
    outline: 'none !important',

    '& *': {
      color: '#222222',
    },

    'div[role="listbox"]': {
      paddingBottom: 0,
      borderRadius: '0px 0px 16px 16px',
      boxShadow: 'none',
      background: '#FFFFFF',
      maxHeight: '150px',

      'div[class$="option"]': {
        background: 'transparent',
        color: '#222222',
        px: '18px',
        py: '6px',
        width: '100%',
      },

      'div[class$="option"]:hover': {
        backgroundColor: '#f37021',
        color: 'white',
        cursor: 'pointer',
      },

      '::-webkit-scrollbar': {
        width: 6,
        borderRadius: '3px',
      },

      '::-webkit-scrollbar-track': {
        background: 'transparent',
        borderRadius: '3px',
      },

      '::-webkit-scrollbar-thumb': {
        background: 'bydb-green',
        borderRadius: '3px',
      },
    },

    '[class$="-indicatorSeparator"]': {
      display: 'none',
    },
  },

  ['.error-select > [class$="-control"]']: {
    borderColor: 'error',
  },
}

export const buildYourDreamBagForms = {
  container: {
    position: 'relative',
    zIndex: 2,
    padding: '0px 16px',
    fontFamily: 'din-light-cn',
    fontSize: '18px',

    'label[for$="_terms_and_conditions"]': {
      marginTop: '32px',
    },

    button: {
      marginTop: '32px',
      marginBottom: '32px',
    },
  },
  inputContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
    marginBottom: '12px',

    label: {
      color: 'white',
      fontFamily: 'din-medium-cn',
      fontSize: '18px',
      backgroundColor: 'transparent',
      pb: '8px',
    },

    ['.error-input']: {
      borderColor: 'error',
    },

    input: {
      borderRadius: '30px',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'bydb-white',
      color: 'bydb-white',
      background: 'bydb-black',
      padding: '10px',
      marginBottom: 0,
      boxShadow: 'none',
      outline: 'none',
      fontFamily: 'din-light-cn',
      fontSize: '18px',
      pl: '16px',
      height: '45px',

      '::placeholder': {
        fontFamily: 'din-light-cn',
        fontSize: '18px',
        color: 'bydb-light-gray',
      },

      '&:-webkit-autofill::first-line': {
        fontSize: '18px !important',
        color: 'var(--theme-ui-colors-bydb-white) !important',
      },

      '&:-webkit-autofill': {
        boxShadow: '0 0 0 1000px transparent inset',
        WebkitTextFillColor: '#FFFFFF',
        transition: 'background-color 5000s ease-in-out 0s',
        color: 'var(--theme-ui-colors-bydb-white) !important',
      },
      '&:-webkit-autofill:hover': {
        color: 'var(--theme-ui-colors-bydb-white) !important',
      },
      '&:-webkit-autofill:focus': {
        boxShadow: '0 0 0 1000px transparent inset',
        color: 'var(--theme-ui-colors-bydb-white) !important',
      },
    },
  },
  errorMessage: {
    color: 'error',
    mt: '7px',
    mb: '12px',
    fontFamily: 'din-light-cn',
    fontSize: '18px',
  },
  countryContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
    marginBottom: '12px',

    label: {
      color: 'white',
      backgroundColor: 'transparent',
      fontFamily: 'din-medium-cn',
      fontSize: '18px',
      pb: '8px',
    },

    input: {
      '&:-webkit-autofill': {
        boxShadow: '0 0 0 1000px transparent inset',
        WebkitTextFillColor: '#fff',
        transition: 'background-color 5000s ease-in-out 0s',
      },
      '&:-webkit-autofill:hover': {
        boxShadow: '0 0 0 1000px transparent inset',
      },
      '&:-webkit-autofill:focus': {
        boxShadow: '0 0 0 1000px transparent inset',
      },
    },

    ...bydbSelectStyles,
  },
  countyContainer: bydbSelectStyles,
  countrySubdivisionContainer: bydbSelectStyles,
  selectContainer: bydbSelectStyles,
  select: {
    control: {
      borderRadius: 'none',
    },
    placeholder: {
      fontFamily: 'din-light-cn',
      color: 'primary',
    },
  },
  phoneContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
  },
  checkboxContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
    fontFamily: 'din-light-cn',
    fontSize: '14px',
    mb: '12px',

    svg: {
      cursor: 'pointer',

      '&:focus, &:active': {
        outline: 'none !important',
      },
    },

    label: {
      cursor: 'pointer',
    },

    a: {
      textDecoration: 'underline !important',
    },
  },
  multipleCheckboxesContainer: {
    fontSize: '18px',
    mb: '12px',

    legend: {
      fontFamily: 'din-medium-cn',
    },

    label: {
      cursor: 'pointer',
    },
  },
  multipleCheckboxes: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '10px',
    mt: '9px',

    svg: {
      cursor: 'pointer',

      '&:focus, &:active': {
        outline: 'none !important',
      },
    },
  },
  button: {
    background: 'primary',
    width: '50%',
  },
  checkbox: {
    div: {
      label: {
        div: {
          'input:checked~svg': {
            color: 'secondary',

            '&:focus, &:active': {
              outline: 'none !important',
            },
          },
          'input~svg': {
            color: 'secondary',

            '&:focus, &:active': {
              outline: 'none !important',
            },
          },
          p: {
            fontFamily: 'light',
            fontSize: '16px',
            lineHeight: '22px',
            a: {
              fontFamily: 'din-light-cn',
              color: 'primary',
              textDecoration: 'underline !important',
            },
          },
        },
      },
    },
  },
  submitContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
    display: 'flex',
    justifyContent: 'center',
    width: ['100%', '97%'],
    button: {
      variant: 'buttons.primary',
    },
  },
}

export const greatestHitsForms = {
  container: {
    contact: {
      justifyContent: 'center',
      display: 'grid',
      rowGap: '17px',
      width: '100%',
    },
    survey: {
      justifyContent: 'center',
      display: 'grid',
      rowGap: '17px',
      width: '100%',
    },
  },
  inputContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
    color: 'textDark',
    label: {
      fontSize: '17px',
      pb: '9px',
    },
  },
  input: {
    height: '40px',
    background: 'background',
    border: '1px solid',
    borderColor: 'textDark',
    borderRadius: '0',
    p: '10px',
    '--theme-ui-input-autofill': {
      backgroundColor: 'background',
    },
    ':-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 30px #fff inset !important',
      WebkitTextFillColor: 'textDark !important',
    },
    ':-webkit-autofill:hover': {
      WebkitBoxShadow: '0 0 0 30px #FFF inset !important',
    },
    ':-webkit-autofill:focus': {
      WebkitBoxShadow: '0 0 0 30px #fff inset !important',
      WebkitTextFillColor: 'textDark !important',
    },
    ':-webkit-autofill:active': {
      WebkitBoxShadow: '0 0 0 30px #fff inset !important',
    },
  },
  errorMessage: {
    color: 'error',
    marginTop: '9px',
    fontSize: '10px',
  },
  countryContainer: greatestHitsSelectStyles,
  countrySubdivisionContainer: greatestHitsSelectStyles,
  countyContainer: greatestHitsSelectStyles,
  selectContainer: greatestHitsSelectStyles,
  checkboxContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
    div: {
      '.error-message': { marginLeft: '32px' },
      label: {
        div: {
          'input:checked~svg': {
            fill: 'textDark',
          },
          'input~svg': {
            fill: 'textDark',
          },
          p: {
            color: 'textDark',
            fontFamily: 'regular',
            fontSize: ['12px', '14px'],
            lineHeight: '18px',
            a: {
              color: '#DFA511',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
  },
  multipleCheckboxesContainer: {
    fontSize: '17px',
    color: 'textDark',
  },
  multipleCheckboxes: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '10px',
    mt: '9px',
  },
  submitContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
    display: 'flex',
    justifyContent: 'center',
    button: {
      width: ['100%', '354px'],
      height: '50px',
      background: 'primary',
      border: '1px solid',
      borderColor: 'primary',
      color: 'textLight',
      fontFamily: 'bold',
      fontSize: '20px',
      lineHeight: '24px',
      '&:hover': {
        color: 'primary',
        background: 'background',
      },
    },
  },
}

export const ultimateCoachingTripForms = {
  container: {
    contact: {
      justifyContent: 'center',
      display: 'grid',
      rowGap: '10px',
      width: '100%',
      padding: '0 16px',
    },
    survey: {
      justifyContent: 'center',
      display: 'grid',
      rowGap: '10px',
      width: '100%',
      padding: '0 16px',
    },
  },
  inputContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
    color: 'textLight',
    label: {
      fontSize: '16px',
      pb: '9px',
    },
  },
  input: {
    height: '40px',
    background: 'background',
    border: '1px solid',
    borderColor: 'textLight',
    borderRadius: '0',
    p: '10px',
    fontSize: '16px',
    '::placeholder': {
      color: 'textLight',
      fontFamily: 'light',
    },
    '--theme-ui-input-autofill': {
      backgroundColor: 'background',
    },
    ':-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 30px #0B2439 inset !important',
      WebkitTextFillColor: '#FFF !important',
    },
    ':-webkit-autofill:hover': {
      WebkitBoxShadow: '0 0 0 30px #0B2439 inset !important',
    },
    ':-webkit-autofill:focus': {
      WebkitBoxShadow: '0 0 0 30px #0B2439 inset !important',
      WebkitTextFillColor: '#FFF !important',
    },
    ':-webkit-autofill:active': {
      WebkitBoxShadow: '0 0 0 30px #0B2439 inset !important',
    },
  },
  errorMessage: {
    color: 'error',
    marginTop: '9px',
    fontSize: '16px',
  },
  markdownContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
    color: 'textLight',
    fontFamily: 'light',
    fontSize: '16px',
  },
  countryContainer: ultimateCoachingTripSelectStyles,
  countrySubdivisionContainer: ultimateCoachingTripSelectStyles,
  countyContainer: ultimateCoachingTripSelectStyles,
  selectContainer: ultimateCoachingTripSelectStyles,
  checkboxContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
    div: {
      '.error-message': { marginLeft: '32px' },
      label: {
        div: {
          'input:checked~svg': {
            fill: 'textLight',
          },
          'input~svg': {
            fill: 'textLight',
          },
          p: {
            color: 'textLight',
            fontFamily: 'light',
            fontSize: '16px',
            lineHeight: '18px',
            a: {
              color: 'secondary',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
  },
  multipleCheckboxesContainer: {
    fontSize: '16px',
    color: 'textLight',
  },
  multipleCheckboxes: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '10px',
    mt: '9px',
    'input~svg': {
      fill: 'textLight',
    },
  },
  submitContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
    display: 'flex',
    justifyContent: 'center',
    button: {
      width: '100%',
      height: '50px',
      background: 'textLight',
      border: '1px solid',
      borderColor: 'textLight',
      color: 'textDark',
      fontFamily: 'bold',
      fontSize: '20px',
      lineHeight: '24px',
      '&:hover': {
        color: 'textLight',
        background: 'background',
      },
    },
  },
}

export const stwForms = {
  container: {
    position: 'relative',
    padding: '0px 16px',
    fontFamily: 'din-light',
    fontSize: '18px',
    zIndex: 2,

    'label[for$="_terms_and_conditions"]': {
      marginTop: '32px',
    },
  },
  inputContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
    marginBottom: '15px',

    label: {
      color: 'white',
      fontFamily: 'din-medium-cn',
      fontSize: '18px',
      backgroundColor: 'transparent',
      pb: '8px',
    },

    ['.error-input']: {
      borderColor: 'error',
    },

    input: {
      display: 'flex',
      alignItems: 'center',
      borderRadius: '30px',
      background: 'white',
      padding: '10px',
      marginBottom: 0,
      outline: 'none',
      fontFamily: 'din-light-cn',
      fontSize: '16px',
      pl: '24px',
      height: '47px',
      boxShadow: '0 0 0 1000px white inset',
      transition: 'background-color 5000s ease-in-out 0s',
      color: '#222222',

      '::placeholder': {
        fontFamily: 'din-light-cn',
        fontSize: '16px',
        color: 'rgba(135,135,135,.5)',
        display: 'flex',
        alignItems: 'center',
      },

      '&:-webkit-autofill::first-line': {
        fontSize: '16px !important',
        color: '#222222 !important',
      },

      '&:-webkit-autofill': {
        boxShadow: '0 0 0 1000px white inset',
        WebkitTextFillColor: '#222222',
        transition: 'background-color 5000s ease-in-out 0s',
        color: '#222222 !important',
      },
      '&:-webkit-autofill:hover': {
        color: '#222222 !important',
      },
      '&:-webkit-autofill:focus': {
        boxShadow: '0 0 0 1000px white inset',
        color: '#222222 !important',
      },
    },
  },
  errorMessage: {
    color: '#f37021',
    mt: '7px',
    mb: '12px',
    fontFamily: 'din-light-cn',
    fontSize: '18px',
  },
  countryContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
    marginBottom: '15px',

    label: {
      color: 'white',
      backgroundColor: 'transparent',
      fontFamily: 'din-medium-cn',
      fontSize: '18px',
      pb: '8px',
    },

    input: {
      pl: '24px',
    },

    ...stwSelectStyles,
  },
  countyContainer: stwSelectStyles,
  countrySubdivisionContainer: stwSelectStyles,
  selectContainer: stwSelectStyles,
  select: {
    control: {
      borderRadius: 'none',
    },
    placeholder: {
      fontFamily: 'din-light-cn',
      color: 'primary',
    },
  },
  phoneContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
  },
  checkboxContainer: {
    gridColumnStart: '1',
    gridColumnEnd: '3',
    fontFamily: 'din-light-cn',
    fontSize: '14px',
    marginBottom: '15px',

    svg: {
      borderRadius: '50%',
      cursor: 'pointer',

      '&:focus, &:active': {
        outline: 'none !important',
      },
    },

    label: {
      cursor: 'pointer',
      my: '12px',

      div: {
        'input:checked~svg:first-of-type': {
          height: '18px',
          width: '18px',
          borderRadius: '50%',
          color: '#f37021',
          border: '1px solid #f37021',
          background: '#f37021',
          display: 'flex',

          '&:focus, &:active': {
            outline: 'none !important',
          },

          '& path': {
            fill: 'white',
          },
        },

        'input~svg': {
          height: '18px',
          width: '18px',
          borderRadius: '50%',
          color: 'transparent',
          border: '1px solid white',

          '&:focus, &:active': {
            outline: 'none !important',
          },
        },

        p: {
          fontFamily: 'din-light',
          fontSize: '14px',
          lineHeight: '130%',

          a: {
            fontFamily: 'din-light',
            color: '#f37021 !important',
            textDecoration: 'underline',
            fontSize: '14px',
          },
        },
      },
    },
  },
  multipleCheckboxesContainer: {
    fontSize: '18px',
    mb: '15px',

    legend: {
      fontFamily: 'din-medium-cn',
    },

    label: {
      fontSize: '16px',
      fontFamily: 'din-light-cn',
      cursor: 'pointer',
    },
  },
  multipleCheckboxes: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '10px',
    mt: '9px',

    svg: {
      height: '18px',
      width: '18px',
      borderRadius: '50%',
      color: 'transparent',
      border: '1px solid white',
      cursor: 'pointer',

      '&:focus, &:active': {
        outline: 'none !important',
      },
    },

    'input:checked~svg:first-of-type': {
      height: '18px',
      width: '18px',
      borderRadius: '50%',
      color: '#f37021',
      border: '1px solid #f37021',
      background: '#f37021',
      display: 'flex',

      '&:focus, &:active': {
        outline: 'none !important',
      },

      '& path': {
        fill: 'white',
      },
    },
  },
  submitContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',

    button: {
      variant: 'primary',

      [MEDIA.MIN_LG]: {
        position: 'absolute',
        bottom: '-30px',
      },
    },
  },
}
